import GithubProfile from './GithubProfile.jsx';

import './gh-profile-media.scss';

export default GithubProfile;
